import { useState } from 'react';
import TemplateManager from './TemplateManager';
import BoatConfigSettings from './BoatConfigSettings';
import TeamSquadSettings from './TeamSquadSettings';
import PositionSettings from './PositionSettings';
import AssetStatusSettings from './AssetStatusSettings';

export default function ConfigSettings({ user }) {
  const [activeTab, setActiveTab] = useState('templates');

  const canManageEquipment = user?.can_manage_equipment ?? false;
  const canAccessConfig = user?.can_access_config ?? false;

  return (
    <div className="stack" style={{ gap: 12 }}>
      <div className="card" style={{ padding: 12 }}>
        <h2 className="h2" style={{ marginTop: 0, marginBottom: 8 }}>Configuration</h2>
        <p className="help" style={{ margin: 0, marginBottom: 12 }}>
          Manage lineup templates, boat assets, teams, squads, positions, and asset status
        </p>

        <div className="btn-group">
          <button
            className={`btn ghost ${activeTab === 'templates' ? 'active' : ''}`}
            onClick={() => setActiveTab('templates')}
          >
            Templates
          </button>
          {canManageEquipment && (
            <button
              className={`btn ghost ${activeTab === 'assets' ? 'active' : ''}`}
              onClick={() => setActiveTab('assets')}
            >
              Assets
            </button>
          )}
          {canAccessConfig && (
            <button
              className={`btn ghost ${activeTab === 'teamsquads' ? 'active' : ''}`}
              onClick={() => setActiveTab('teamsquads')}
            >
              Teams & Squads
            </button>
          )}
          {canAccessConfig && (
            <button
              className={`btn ghost ${activeTab === 'positions' ? 'active' : ''}`}
              onClick={() => setActiveTab('positions')}
            >
              Positions
            </button>
          )}
          {canAccessConfig && (
            <button
              className={`btn ghost ${activeTab === 'assetstatus' ? 'active' : ''}`}
              onClick={() => setActiveTab('assetstatus')}
            >
              Asset Status
            </button>
          )}
        </div>
      </div>

      {activeTab === 'templates' && <TemplateManager />}
      {activeTab === 'assets' && (
        canManageEquipment ? (
          <BoatConfigSettings />
        ) : (
          <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
            <p>You do not have permission to manage equipment.</p>
          </div>
        )
      )}
      {activeTab === 'teamsquads' && (
        canAccessConfig ? (
          <TeamSquadSettings />
        ) : (
          <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
            <p>You do not have permission to access this feature.</p>
          </div>
        )
      )}
      {activeTab === 'positions' && (
        canAccessConfig ? (
          <PositionSettings />
        ) : (
          <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
            <p>You do not have permission to access this feature.</p>
          </div>
        )
      )}
      {activeTab === 'assetstatus' && (
        canAccessConfig ? (
          <AssetStatusSettings />
        ) : (
          <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
            <p>You do not have permission to access this feature.</p>
          </div>
        )
      )}
    </div>
  );
}
